import { Reveal, StaggerGroup, StaggerItem3D } from "@/components/anim/Reveal";
import Counter from "@/components/anim/Counter";
import Tilt3D from "@/components/anim/Tilt3D";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

const PHONE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/fdc7e537-5c5d-45e2-9d51-2eada049b3ca/images/af5619c32bc42e5267d01617b0aa5976c022e3fcf45dc998ff739e43ec11d914.png";

const STATS_EN = [
  { value: 60, suffix: "%", label: "of buyers now start product research inside AI assistants" },
  { value: 3, prefix: "1 in ", label: "Google searches now ends in an AI answer, not a click" },
  { value: 0, label: "customers come from AI if it never mentions your business" },
];

const STATS_HE = [
  { value: 60, suffix: "%", label: "מהלקוחות מתחילים היום את החיפוש אצל עוזרי AI" },
  { value: 60, suffix: "%", label: "מחיפושי גוגל נגמרים בלי קליק — ה-AI עונה במקום האתרים" },
  { value: 0, label: "לקוחות מגיעים אליכם מה-AI כשהוא לא מזכיר את העסק שלכם בכלל" },
];

const STATS = HE ? STATS_HE : STATS_EN;

export const WhyItMatters = () => (
  <section className="py-20 md:py-28 border-b-2 border-obsidian bg-[#F9F9F9]">
    <div className="av-container">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="flex items-center gap-3 mb-6">
            <div className="h-3 w-3 bg-conversion" />
            <span className="av-label text-obsidian">{t("why.label")}</span>
          </div>
          {HE ? (
            <>
              <h2 className="font-display text-3xl sm:text-5xl leading-[1.05] text-obsidian">
                ה-AI הוא החיפוש החדש. אם הוא לא מזכיר אתכם — אתם לא קיימים.
              </h2>
              <p className="mt-6 text-lg md:text-xl text-neutral-700 leading-relaxed">
                הלקוחות שלכם שואלים עכשיו את <span dir="ltr">ChatGPT</span>, <span dir="ltr">Gemini</span> ו-<span dir="ltr">Google AI</span> מי מומלץ.
                כשה-AI עונה, הוא מצטט קומץ עסקים — ומתעלם מכל השאר. רוב העסקים בכלל לא יודעים
                אם ממליצים עליהם או מדלגים עליהם בשקט.
              </p>
            </>
          ) : (
            <>
              <h2 className="font-display text-3xl sm:text-5xl leading-[1.05] text-obsidian">
                AI is the new search. If it doesn&apos;t mention you, you don&apos;t exist.
              </h2>
              <p className="mt-6 text-lg md:text-xl text-neutral-700 leading-relaxed">
                Your customers are asking ChatGPT, Gemini and Google AI for recommendations right now.
                When AI answers, it cites a handful of brands — and ignores the rest. Most businesses have
                no idea whether they&apos;re being recommended or quietly skipped.
              </p>
            </>
          )}
        </Reveal>

        <Reveal delay={0.15}>
          <Tilt3D max={8} className="max-w-md mx-auto lg:ml-auto">
            <div className="relative border-2 border-obsidian shadow-[12px_12px_0px_0px_rgba(10,10,10,1)] overflow-hidden">
              <img
                src={PHONE_IMG}
                alt={t("why.live")}
                className="w-full h-[340px] sm:h-[420px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-obsidian/85 backdrop-blur-sm px-4 py-3 flex items-center gap-2">
                <span className="h-2 w-2 bg-conversion animate-pulse shrink-0" />
                <span className="font-data text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-white">
                  {t("why.live")}
                </span>
              </div>
            </div>
          </Tilt3D>
        </Reveal>
      </div>

      <StaggerGroup className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14" gap={0.12}>
        {STATS.map((s) => (
          <StaggerItem3D key={s.label}>
            <Tilt3D className="h-full">
              <div className="av-card av-card-hover p-8 h-full">
                <div className="font-data text-6xl font-bold text-conversion tracking-tighter" dir="ltr">
                  <Counter to={s.value} prefix={s.prefix || ""} suffix={s.suffix || ""} />
                </div>
                <p className="mt-4 text-neutral-700 leading-relaxed">{s.label}</p>
              </div>
            </Tilt3D>
          </StaggerItem3D>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default WhyItMatters;
